import { sampleBySessionId } from 'posthog-js/dist/customizations';
import { PostHogProvider } from 'posthog-js/react';
import { getAppConfig } from '@/app/config';
import { getUrlProperties } from './urlProperties';

export const AnalyticsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { environment, posthog } = getAppConfig();

  if (!posthog?.key) return children;

  const sampleSession = sampleBySessionId(posthog.sampleRate);

  return (
    <PostHogProvider
      apiKey={posthog.key}
      options={{
        api_host: posthog.host,
        defaults: '2025-05-24',
        disable_session_recording: true,
        enable_recording_console_log: false,
        session_recording: {
          maskAllInputs: true,
          maskTextSelector: '*',
          recordHeaders: false,
          recordBody: false,
          captureCanvas: { recordCanvas: false },
          maskCapturedNetworkRequestFn: (request) => ({
            ...request,
            name: request.name.replace(/\?.*$/, ''),
            requestHeaders: undefined,
            requestBody: undefined,
            responseHeaders: undefined,
            responseBody: undefined,
          }),
        },
        before_send: (event) => {
          const sampled = posthog.sampleRate < 1 ? sampleSession(event) : event;
          return (
            sampled && {
              ...sampled,
              properties: {
                environment,
                ...getUrlProperties(window.location.search),
                ...sampled.properties,
              },
            }
          );
        },
      }}
    >
      {children}
    </PostHogProvider>
  );
};
